import objectPath from 'object-path'
import { checkCondition, getConditionKey } from './condition/State'

export const checkFalseFromAndOr = (
  actions,
  checkFalse,
  connector,
  isWaiting
) => {
  if (actions.length === 0) return checkFalse
  let shift = actions.shift()

  if (checkFalse === null) {
    checkFalse = shift
  } else {
    if (shift === 'and') {
      connector = shift
      isWaiting = true
    } else if (shift === 'or') {
      connector = shift
    } else {
      if (isWaiting) {
        if (checkFalse === false && shift === true) {
          if (connector === 'or') {
            checkFalse = true
            return checkFalse
          }
        }
        if (checkFalse === true && shift === false) {
          if (connector === 'or') {
            checkFalse = true
            return checkFalse
          }
          if (connector === 'and') {
            checkFalse = false
            isWaiting = false
          }
        }
        if (actions.length === 0) {
          isWaiting = false
        } else {
          if (checkFalse === true && shift === true) {
            isWaiting = true
          }
        }
      } else {
        if (checkFalse === true) {
          if (connector === 'or') {
            checkFalse = true
            return checkFalse
          }
        } else if (checkFalse === false) {
          if (connector === 'or' && shift === true) {
            checkFalse = true
            isWaiting = true
          }
        }
      }
    }
  }
  return checkFalseFromAndOr(actions, checkFalse, connector, isWaiting)
}

export const showInvisibleElementAction = (elementAction, isShowInvisible) => {
  let doOrder = objectPath.get(elementAction, 'doOrder')
  if (!doOrder) return elementAction
  doOrder.forEach((list) => {
    let allAction = { isEqual: [] }
    let doList = null
    list.forEach((key) => {
      let [conditionKey, conditionState, conditionValue] = key.split('.')
      let mainKey = [conditionKey, conditionState].join('.')
      if (conditionKey === 'and') {
        objectPath.push(allAction, conditionState, conditionKey)
      } else if (conditionKey === 'or') {
        objectPath.push(allAction, conditionState, conditionKey)
      } else {
        let condition = objectPath.get(elementAction, mainKey)
        let { doAction } = condition
        doList = doAction
      }
    })
    if (doList) {
      Object.keys(doList).forEach((key) => {
        let state = objectPath.get(doList, key)
        if (state === 'isShow') {
          objectPath.set(elementAction, [state, key], isShowInvisible)
        }
      })
    }
  })

  return elementAction
}

export const showVisibleAll = (elementAction, isShowInvisible) => {
  let isShow = objectPath.get(elementAction, 'isShow')
  if (isShow) {
    Object.keys(isShow).forEach((key) => {
      objectPath.set(elementAction, ['isShow', key], {
        isShow: isShowInvisible,
      })
    })
  }
  return elementAction
}

export const checkEnableContainer = (
  key,
  isEnable,
  jsonForm,
  elementAction
) => {
  let mapKey = jsonForm.schema.mapKey
  let filterElement
  if (key === 'all') {
    filterElement = Object.keys(mapKey)
  } else {
    let containerKey = objectPath.get(mapKey, key)
    filterElement = Object.keys(mapKey).filter((key) => {
      let elementKey = objectPath.get(mapKey, key)
      return elementKey.startsWith(containerKey)
    })
  }
  filterElement.forEach((key) => {
    objectPath.set(elementAction, ['isEnable', key], isEnable)
  })
  return elementAction
}

export const updateElementAction = (
  designContext,
  elementAction,
  uiKey,
  formData,
  jsonForm
) => {
  let doOrder = objectPath.get(elementAction, 'doOrder')
  let [groupKey = '', subKey = ''] = uiKey.split('.')
  if (!doOrder) return elementAction
  let isSetting = []
  doOrder.forEach((list, index) => {
    let allAction = []
    let doList = null
    let checkFalseList = []
    let found = list.find((item) => {
      let keyList = item.split('.')
      return keyList.includes(groupKey) || keyList.includes(subKey)
    })

    if (found) {
      list.forEach((key) => {
        let { conditionKey, conditionState, conditionValue } =
          getConditionKey(key)
        let mainKey = [conditionKey, conditionState].join('.')
        if (conditionKey === 'and') {
          objectPath.push(allAction, index, conditionKey)
        } else if (conditionKey === 'or') {
          objectPath.push(allAction, index, conditionKey)
        } else {
          let checkValue = checkCondition(
            designContext,
            { conditionKey, conditionState, conditionValue },
            { formData: formData }
          )
          objectPath.push(allAction, index, checkValue)
          let condition = objectPath.get(elementAction, mainKey)
          if (condition) {
            let { doAction } = condition
            doList = doAction
          }
        }
      })

      allAction.forEach((actions) => {
        let checkFalse = null
        if (actions.includes('and') && actions.includes('or')) {
          let checkActions = actions
          checkFalse = checkFalseFromAndOr(checkActions, checkFalse, '', false)
        } else if (actions.includes('and')) {
          if (actions.includes(false)) {
            checkFalse = false
          } else {
            checkFalse = true
          }
        } else if (actions.includes('or')) {
          if (actions.includes(true)) {
            checkFalse = true
          } else {
            checkFalse = false
          }
        } else {
          if (actions.includes(true)) {
            checkFalse = true
          } else {
            checkFalse = false
          }
        }

        objectPath.set(checkFalseList, [index], checkFalse)
      })
      if (doList) {
        Object.keys(doList).forEach((key) => {
          let states = objectPath.get(doList, key)
          let hasChecked = objectPath.has(checkFalseList, index)
          if (!hasChecked) return
          let checked = objectPath.get(checkFalseList, index)
          states.forEach((state) => {
            if (state === 'isRequire') {
              let actionRequire = objectPath.get(elementAction, [
                'actionRequire',
                index,
                key,
              ])
              let requireOnSubmit = objectPath.get(elementAction, [
                'requireOnSubmit',
                index,
                key,
              ])
              if (requireOnSubmit) {
                objectPath.set(elementAction, [state, key], checked)
              } else {
                objectPath.set(elementAction, [state, key], actionRequire)
              }
            } else if (state === 'isWarning') {
              let actionWarning = objectPath.get(elementAction, [
                'actionWarning',
                index,
                key,
              ])
              let warningOnSubmit = objectPath.get(elementAction, [
                'warningOnSubmit',
                index,
                key,
              ])
              if (warningOnSubmit) {
                objectPath.set(elementAction, [state, key], checked)
              } else {
                objectPath.set(
                  elementAction,
                  [state, key],
                  checked ? actionWarning : ''
                )
              }
            } else if (state === 'dateToAge') {
              let conditionKey = objectPath.get(elementAction, [
                'conditionKey',
                index,
              ])
              objectPath.set(elementAction, [state, key], conditionKey)
            } else {
              objectPath.set(elementAction, [state, key], checked)
            }
          })
        })
      }
    }
  })
  return elementAction || {}
}

export const getElementAction = (designContext, conditions = [], jsonForm) => {
  return {}
  let formData = jsonForm.formData
  let elementAction = {}
  let provider = objectPath.set(elementAction, ['provider']) || []
  conditions.forEach(
    (
      {
        conditions = [],
        actions = [],
        connector = [],
        isEnabled,
        key,
        isProvider,
      },
      index
    ) => {
      if (!isEnabled) return
      if (isProvider) {
        provider = provider.concat(conditions)
        objectPath.set(elementAction, ['provider'], provider)
        return
      }
      conditions.forEach((condition, conditionIndex) => {
        let conditionKey = condition.key

        let conditionKeys =
          objectPath.get(elementAction, ['conditionKey', index]) || []
        if (!conditionKey) return
        if (!conditionKeys.includes(conditionKey)) {
          objectPath.push(elementAction, ['conditionKey', index], conditionKey)
        }

        let conditionState = condition.state

        let stateValue
        if (
          objectPath.has(condition, [conditionState, 'value', conditionKey])
        ) {
          stateValue = objectPath.get(condition, [
            conditionState,
            'value',
            conditionKey,
          ])
        } else {
          stateValue = objectPath.get(condition, 'value')
        }
        if (!objectPath.has(elementAction, [conditionKey, conditionState])) {
          objectPath.set(
            elementAction,
            [conditionKey, conditionState, 'stateValue'],
            stateValue
          )
        }
        if (conditionKey && conditionState) {
          let value = ''
          if (stateValue === undefined) {
            value = [conditionKey, conditionState].join('.')
            objectPath.push(elementAction, ['doOrder', index], value)
          } else if (typeof stateValue === 'object') {
            let list = Object.keys(stateValue)
            let lastIndex = list.length - 1
            if (lastIndex > -1) {
              list.forEach((stateKey, stateIndex) => {
                let value = [conditionKey, conditionState, stateKey].join('.')
                objectPath.push(elementAction, ['doOrder', index], value)
                if (stateIndex === lastIndex) return
                if (conditionState === 'isAllOf') {
                  objectPath.push(elementAction, ['doOrder', index], 'and')
                } else if (conditionState === 'isAnyOf') {
                  objectPath.push(elementAction, ['doOrder', index], 'or')
                }
              })
            }
          } else {
            value = [conditionKey, conditionState, stateValue].join('.')
            objectPath.push(elementAction, ['doOrder', index], value)
          }

          let connect = objectPath.get(connector, conditionIndex)
          if (connect) {
            objectPath.push(elementAction, ['doOrder', index], connect)
          }
        }
        actions.forEach((action) => {
          let actionKey = action.key
          let actionKeys =
            objectPath.get(elementAction, ['actionKey', index]) || []
          if (!actionKey) return
          if (!actionKeys.includes(actionKey)) {
            objectPath.push(elementAction, ['actionKey', index], actionKey)
          }
          let actionState = action.state
          let actionValue = objectPath.get(action, [
            actionState,
            'value',
            actionKey,
          ])
          objectPath.set(
            elementAction,
            ['actionValue', index, actionKey],
            actionValue
          )
          let actionRequire = objectPath.get(action, [
            actionState,
            'requireMessage',
          ])
          let requireOnSubmit = objectPath.get(action, [
            actionState,
            'requireOnSubmit',
          ])
          objectPath.set(
            elementAction,
            ['actionRequire', index, actionKey],
            actionRequire
          )
          objectPath.set(
            elementAction,
            ['requireOnSubmit', index, actionKey],
            requireOnSubmit
          )
          let actionWarning = objectPath.get(action, [
            actionState,
            'warningMessage',
          ])
          let warningOnSubmit = objectPath.get(action, [
            actionState,
            'warningOnSubmit',
          ])

          objectPath.set(
            elementAction,
            ['actionWarning', index, actionKey],
            actionWarning
          )
          objectPath.set(
            elementAction,
            ['warningOnSubmit', index, actionKey],
            warningOnSubmit
          )
          objectPath.push(
            elementAction,
            [conditionKey, conditionState, 'doAction', actionKey],
            actionState
          )

          if (actionState === 'isCopy') {
            objectPath.push(
              elementAction,
              ['actionCopy', conditionKey],
              actionKey
            )
            objectPath.set(elementAction, [actionState, actionKey], true)
          } else if (actionState === 'callAPI') {
            let actionAPI =
              objectPath.get(elementAction, ['actionAPI', conditionKey]) || []
            if (!actionAPI.includes(actionKey)) {
              objectPath.push(
                elementAction,
                ['actionAPI', conditionKey],
                actionKey
              )
            }
          } else if (actionState === 'callTableApi') {
            objectPath.set(
              elementAction,
              ['actionCallTableApi', actionKey],
              conditionKey
            )
          } else if (actionState === 'updateCheckboxList') {
            objectPath.set(
              elementAction,
              ['actionUpdateCheckbox', actionKey],
              conditionKey
            )
          } else if (actionState === 'isShowHideList') {
            objectPath.set(
              elementAction,
              ['actionShowHideList', actionKey],
              conditionKey
            )
          } else if (actionState === 'selectRowTable') {
            objectPath.set(
              elementAction,
              ['actionSelectRowTable', actionKey],
              conditionKey
            )
          } else if (actionState === 'activeButton') {
            objectPath.set(
              elementAction,
              ['actionActiveButton', actionKey],
              conditionKey
            )
          }
        })
      })
    }
  )
  formData = formData || jsonForm.formData
  Object.keys(elementAction).forEach((key) => {
    let isCorrectKey = objectPath.get(jsonForm, `schema.mapKey.${key}`)
    let isฺButton =
      ['button', 'buttonDropdown'].includes(
        objectPath.get(jsonForm, `schema.mapTag.${key}`)
      )
    if (isCorrectKey && !isฺButton) {
      elementAction = updateElementAction(
        designContext,
        elementAction,
        key,
        formData,
        jsonForm
      )
    }
  })
  console.log('elementAction', elementAction)
  return elementAction || {}
}

export const updateCondition = async (
  showInvisible,
  formData,
  uiKey,
  designContext
) => {
  let { elementAction, setElementAction, jsonForm } = designContext
  let hasUpdate = objectPath.has(elementAction, uiKey)
  if (!hasUpdate) return formData
  if (showInvisible) {
    showInvisibleElementAction(elementAction, showInvisible)
  } else {
    updateElementAction(designContext, elementAction, uiKey, formData, jsonForm)
  }
  return formData
}

export const copyDataByCondition = (value, elementAction, uiKey, formData) => {
  let actionCopy = objectPath.get(elementAction, ['actionCopy', uiKey])
  if (actionCopy) {
    actionCopy.forEach((key) => {
      objectPath.set(formData, key, value)
    })
  }
  return formData
}
